// extracted by mini-css-extract-plugin
export var card = "_a2-0";
export var failedIcon = "_a2-4";
export var failedIconBadge = "_a2-3";
export var icon = "_a2-1";
export var successIcon = "_a2-2";